import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/header';
import fundo1 from './assets/images/fundo-site-1.jpeg';
import fundo2 from './assets/images/fundo-site-2.jpg';
import fundo22 from './assets/images/fundo-site-2-2.jpeg';
import fundo3 from './assets/images/fundo-site-3.jpg';
import fundo4 from './assets/images/fundo-site-4.jpg';
import fundo5 from './assets/images/fundo-site-5.jpg';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme'
import RoutePaths from './routes';
import FloatingWhatApp from './components/floatingWhatsApp';
import useTrackPageview from './useTrackPageview';
import './i18n';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

function capturarUTMNaEntrada() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utms = {};
    let temAlgumUTM = false;

    UTM_KEYS.forEach((chave) => {
      const valor = params.get(chave) || '';
      utms[chave] = valor;
      if (valor !== '') temAlgumUTM = true;
    });

    if (temAlgumUTM) {
      sessionStorage.setItem('utm_data', JSON.stringify(utms));
    }
  } catch (e) {
    // sessionStorage pode estar bloqueado (modo privado/iframe) — nunca derrubar o app por causa de UTM
  }
}

// Executa já na carga do bundle: pega a URL de entrada antes de o router
// montar e de qualquer navegação/redirect descartar a query string
capturarUTMNaEntrada();

const Home = React.lazy(() => import('./pages/home'));
const Geradores = React.lazy(() => import('./pages/geradores'));
const Contato = React.lazy(() => import('./pages/contato'));
const Cobertura = React.lazy(() => import('./pages/cobertura'));
const QuemSomos = React.lazy(() => import('./pages/quemSomos'));

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useTrackPageview();

  const [previousLocation, setPreviousLocation] = useState(location.pathname);
  const [actualLocation, setActualLocation] = useState(location.pathname);
  const [pageHeight, setPageHeight] = useState("100vh");

  const headerRef = useRef(null);


  const isSmallScreen = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    if (isSmallScreen && actualLocation === RoutePaths.CONTATO.path) {
      setPageHeight("150vh");
    } else if (isSmallScreen && actualLocation === RoutePaths.COBERTURA.path) {
      setPageHeight("130vh");
    } else if (isSmallScreen && actualLocation === RoutePaths.QUEMSOMOS.path) {
      setPageHeight("130vh");
    } else {
      setPageHeight("100vh");
    }
  }, [isSmallScreen, actualLocation]);

  const orderedRoutes = [
    RoutePaths.HOME.path,
    RoutePaths.GERADORES.path,
    RoutePaths.COBERTURA.path,
    RoutePaths.CONTATO.path,
    RoutePaths.QUEMSOMOS.path
  ];

  const getBackground = () => {
    switch (location.pathname) {
      case RoutePaths.HOME.path:
        return fundo1;
      case RoutePaths.GERADORES.path:
        return fundo2;
      case RoutePaths.COBERTURA.path:
        return fundo3;
      case RoutePaths.CONTATO.path:
        return fundo4;
      case RoutePaths.QUEMSOMOS.path:
        return fundo5;
      default:
        return 'none';
    }
  };

  const getOpacity = () => {
    switch (location.pathname) {
      case RoutePaths.HOME.path:
        return "rgba(0, 0, 0, 0.6)";
      case RoutePaths.GERADORES.path:
        return "rgba(0, 0, 0, 0.4)";
      case RoutePaths.COBERTURA.path:
        return "rgba(0, 0, 0, 0.6)";
      case RoutePaths.CONTATO.path:
        return "rgba(0, 0, 0, 0.3)";
      case RoutePaths.QUEMSOMOS.path:
        return "rgba(0, 0, 0, 0.75)";
      default:
        return "rgba(0, 0, 0, 0.3)";
    }
  };

  const getPageTransition = useMemo(() => {
    const currentIndex = Object.values(RoutePaths).find(route => route.path === actualLocation)?.index;
    const scroll = Object.values(RoutePaths).find(route => route.path === actualLocation)?.scroll;
    const previousIndex = Object.values(RoutePaths).find(route => route.path === previousLocation)?.index;
    let forwardNavigation = true;

    if ((currentIndex !== undefined && previousIndex !== undefined) && currentIndex !== previousIndex) {
      forwardNavigation = currentIndex > previousIndex;
      setPreviousLocation(actualLocation);
    }

    // Conferir melhor necessidade após mudanças
    if (scroll) {
      setTimeout(() => {
      }, 500);

    }

    return {
      initial: { x: forwardNavigation ? '100%' : '-100%', opacity: 0 },
      animate: { x: 0, opacity: 1 },
      exit: { x: forwardNavigation ? '-100%' : '100%', opacity: 0 },
      transition: { type: 'tween', duration: 0.7 },
    };
  }, [actualLocation]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div
        style={{
          position: 'relative',
          // minHeight:
          //   location.pathname === RoutePaths.GERADORES.path ||
          //     location.pathname === RoutePaths.SERVICOS.path
          //     ? '300vh'
          //     : location.pathname === RoutePaths.CONTATO.path
          //       ? '170vh'
          //       : '100%',
          height:
            location.pathname === RoutePaths.GERADORES.path ||
              location.pathname === RoutePaths.SERVICOS.path
              ? '300vh'
              : location.pathname === RoutePaths.QUEMSOMOS.path && isSmallScreen
                ? '120vh'
              : location.pathname === RoutePaths.COBERTURA.path && isSmallScreen
                ? '130vh'
                : location.pathname === RoutePaths.CONTATO.path && isSmallScreen
                  ? '150vh'
                  : '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1,
        }}
      >
        {/* Fundo com animação */}

        {location.pathname === RoutePaths.HOME.path ? (
          <motion.div

          >
            {/* Renderiza o vídeo para a página Home */}
            <video
              autoPlay
              loop
              muted
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                maxHeight: '100vh',
                height: '100vh',
                objectFit: 'cover',
                zIndex: -1, // Para garantir que o conteúdo fique sobre o vídeo
              }}
            >
              <source src={require('./assets/videos/fundo-site.mp4')} type="video/mp4" />
              Seu navegador não suporta vídeos.
            </video>
          </motion.div>

        ) : location.pathname === RoutePaths.GERADORES.path | location.pathname === RoutePaths.SERVICOS ? (
          <>
            <motion.div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100vh',
                minHeight: '100vh',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'background-image 0.3s ease-in-out',
                // backgroundRepeat: 'no-repeat',
                // backgroundPosition: 'left top',
                zIndex: 0, // Fica no fundo
              }}
              key={`${location.pathname}-2`}
              initial={{ opacity: .8 }}
              animate={{ opacity: 1, backgroundImage: `url(${getBackground()})` }}
              exit={{ opacity: .8 }}
              transition={{ duration: 1 }}
            />

            <motion.div
              style={{
                position: 'absolute',
                top: "100vh",
                height: "100vh",
                left: 0,
                width: '100%',
                // height: '100vh',
                minHeight: '100vh',
                // maxHeight: '100vh',
                backgroundSize: 'cover',
                backgroundImage: `url(${fundo22})`,
                backgroundPosition: 'center',
                transition: 'background-image 0.3s ease-in-out',
                // backgroundRepeat: 'no-repeat',
                // backgroundPosition: 'left top',
                zIndex: 0, // Fica no fundo
              }}
              key={location.pathname}
              initial={{ opacity: .8 }}
              animate={{ opacity: 1, backgroundImage: `url(${fundo22})` }}
              exit={{ opacity: .8 }}
              transition={{ duration: 1 }}
            />

            <motion.div
              style={{
                position: 'absolute',
                top: "200vh",
                height: "100vh",
                left: 0,
                width: '100%',
                minHeight: '100vh',
                background: 'linear-gradient(to bottom, gray, #f5f5f5)', // Gradiente cinza para branco claro
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                transition: 'background 0.3s ease-in-out',
                zIndex: 0, // Fica no fundo
              }}
              key={`${location.pathname}-3`}
              initial={{ opacity: 0.8 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0.8 }}
              transition={{ duration: 1 }}
            />


          </>
        ) : (
          <motion.div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transition: 'background-image 0.3s ease-in-out',
              zIndex: 0, // Fica no fundo
            }}
            key={location.pathname}
            initial={{ opacity: .8 }}
            animate={{ opacity: 1, backgroundImage: `url(${getBackground()})` }}
            exit={{ opacity: .8 }}
            transition={{ duration: 1 }}
          />
        )}

        {/* Sobreposição para opacidade */}
        <div
          style={{
            position: 'absolute',
            // top: location.pathname === RoutePaths.GERADORES.path ? "100vh" : 0,
            top: 0,
            left: 0,
            width: '100%',
            height: location.pathname === RoutePaths.GERADORES.path ? '100vh' : 
            location.pathname === RoutePaths.HOME.path ? '100vh' :
            '100%',
            backgroundColor: getOpacity(),
            zIndex: 2, // Fica acima do background
          }}
        />

        {/* Conteúdo da página */}
        <div style={{ zIndex: 3, height: pageHeight, display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
          <Header setActualLocation={setActualLocation} actualLocation={actualLocation} ref={headerRef} />

          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              {/* Página HOME */}
              <Route
                index
                path={RoutePaths.HOME.path}
                element={
                  <motion.div
                    key={location.pathname}
                    style={{ flex: 1 }}
                    {...getPageTransition}
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    onDragEnd={(event, info) => {
                      const currentIndex = orderedRoutes.findIndex(
                        (route) => route === location.pathname
                      );

                      if (info.offset.x < -100 && currentIndex < orderedRoutes.length - 1) {
                        // Arrastou para a esquerda e não está na última página
                        navigate(orderedRoutes[currentIndex + 1]);
                        setActualLocation(orderedRoutes[currentIndex + 1]);

                      } else if (info.offset.x > 100 && currentIndex > 0) {
                        // Arrastou para a direita e não está na primeira página
                        navigate(orderedRoutes[currentIndex - 1]);
                        setActualLocation(orderedRoutes[currentIndex - 1]);
                      }
                    }}
                  >
                    <Home setActualLocation={setActualLocation} />
                  </motion.div>
                }
              />

              {/* Página GERADORES */}
              <Route
                path={RoutePaths.GERADORES.path}
                element={
                  <motion.div
                    key={location.pathname}
                    style={{ flex: 1 }}
                    {...getPageTransition}
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    onDragEnd={(event, info) => {
                      const currentIndex = orderedRoutes.findIndex(
                        (route) => route === location.pathname
                      );

                      if (info.offset.x < -100 && currentIndex < orderedRoutes.length - 1) {
                        navigate(orderedRoutes[currentIndex + 1]);
                        setActualLocation(orderedRoutes[currentIndex + 1]);
                      } else if (info.offset.x > 100 && currentIndex > 0) {
                        navigate(orderedRoutes[currentIndex - 1]);
                        setActualLocation(orderedRoutes[currentIndex - 1]);
                      }
                    }}
                  >
                    <Geradores setActualLocation={setActualLocation} />
                  </motion.div>
                }
              />

              {/* Página COBERTURA */}
              <Route
                path={RoutePaths.COBERTURA.path}
                element={
                  <motion.div
                    key={location.pathname}
                    style={{ flex: 1 }}
                    {...getPageTransition}
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    onDragEnd={(event, info) => {
                      const currentIndex = orderedRoutes.findIndex(
                        (route) => route === location.pathname
                      );

                      if (info.offset.x < -100 && currentIndex < orderedRoutes.length - 1) {
                        navigate(orderedRoutes[currentIndex + 1]);
                        setActualLocation(orderedRoutes[currentIndex + 1]);
                      } else if (info.offset.x > 100 && currentIndex > 0) {
                        navigate(orderedRoutes[currentIndex - 1]);
                        setActualLocation(orderedRoutes[currentIndex - 1]);
                      }
                    }}
                  >
                    <Cobertura setActualLocation={setActualLocation} />
                  </motion.div>
                }
              />

              {/* Página CONTATO */}
              <Route
                path={RoutePaths.CONTATO.path}
                element={
                  <motion.div
                    key={location.pathname}
                    style={{ flex: 1 }}
                    {...getPageTransition}
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    onDragEnd={(event, info) => {
                      const currentIndex = orderedRoutes.findIndex(
                        (route) => route === location.pathname
                      );

                      if (info.offset.x < -100 && currentIndex < orderedRoutes.length - 1) {
                        navigate(orderedRoutes[currentIndex + 1]);
                        setActualLocation(orderedRoutes[currentIndex + 1]);
                      } else if (info.offset.x > 100 && currentIndex > 0) {
                        navigate(orderedRoutes[currentIndex - 1]);
                        setActualLocation(orderedRoutes[currentIndex - 1]);
                      }
                    }}
                  >
                    <Contato setActualLocation={setActualLocation} />
                  </motion.div>
                }
              />

              {/* Página QUEM SOMOS */}
              <Route
                path={RoutePaths.QUEMSOMOS.path}
                element={
                  <motion.div
                    key={location.pathname}
                    style={{ flex: 1 }}
                    {...getPageTransition}
                    drag="x"
                    dragConstraints={{ left: 0, right: 0 }}
                    onDragEnd={(event, info) => {
                      const currentIndex = orderedRoutes.findIndex(
                        (route) => route === location.pathname
                      );
                      if (info.offset.x < -100 && currentIndex < orderedRoutes.length - 1) {
                        navigate(orderedRoutes[currentIndex + 1]);
                        setActualLocation(orderedRoutes[currentIndex + 1]);
                      } else if (info.offset.x > 100 && currentIndex > 0) {
                        navigate(orderedRoutes[currentIndex - 1]);
                        setActualLocation(orderedRoutes[currentIndex - 1]);
                      }
                    }}
                  >
                    <QuemSomos setActualLocation={setActualLocation} />
                  </motion.div>
                }
              />
            </Routes>
          </AnimatePresence>

        </div>
      </div>
      <FloatingWhatApp></FloatingWhatApp>
    </ThemeProvider>
  );
}

export default App;
